import type { ReactNode } from 'react';

import type { DataTableColumn } from './data-table';

// ─── Types ────────────────────────────────────────────────────────────────────

interface CreateActionsColumnOptions {
  /** When true the column is pinned and cannot be toggled via ColumnsToggle */
  alwaysOn?: boolean;
  className?: string;
}

// ─── Factory ──────────────────────────────────────────────────────────────────

/**
 * Creates a standardised actions column definition for use with <DataTable />.
 *
 * Eliminates the repeated `{ cell, className: 'w-[60px]', header: '', key: 'actions' }`
 * literal duplicated across all 14 table components.
 */
export function createActionsColumn<T>(
  renderCell: (item: T) => ReactNode,
  options?: CreateActionsColumnOptions,
): DataTableColumn<T> {
  return {
    alwaysOn: options?.alwaysOn,
    cell: renderCell,
    className: options?.className ?? 'w-[60px]',
    header: '',
    key: 'actions',
  };
}
